import React from "react"
import ContainerDimensions from "react-container-dimensions"
import { useTranslate } from "react-admin"
import { Box } from "rebass"
import { Title } from "../components"
import { Dashboard } from "./components"

const InventoryList = (props) => {
  const translate = useTranslate()
  return (
    <Box width={[1]}>
      <Box width={[1]} pt={[2]}>
        <Title fontWeight={"bold"} fontSize={[3]}>
          {translate(`resources.inventory.title`)}
        </Title>
      </Box>
      <ContainerDimensions>
        {({ width, height }) => {
          return (
            <Box width={[1]}>
              <Dashboard {...props} width={width} height={height} />
            </Box>
          )
        }}
      </ContainerDimensions>
    </Box>
  )
}
export default InventoryList
